import Vue from 'vue'
import Vuex from 'vuex'
import { fetchUserInfo } from '@/api/common'

Vue.use(Vuex)


function initUserInfoFromStorage() {
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr) {
      return JSON.parse(userInfoStr);
    }
  } catch (e) {
    console.error('Failed to parse userInfo from localStorage', e);
  }
  return {
    username: '',
    nickname: '',
    avatar: '',
    mobile: '',
    score: 0,
    gender: null,
  };
}

export default new Vuex.Store({
  state: {
    count: 0,
    
    token: localStorage.getItem('token') || '',
    
    userInfo: initUserInfoFromStorage(),
    
    userInfoLoaded: !!localStorage.getItem('isLoggedIn'),
  },
  mutations: {
    INCREMENT(state) {
      state.count++
    },
    DECREMENT(state) {
      state.count--
    },
    
    SET_USER_INFO(state, userInfo) {
      
      state.userInfo = { ...state.userInfo, ...userInfo }
    },
    
    UPDATE_USER_INFO(state, payload) {
      state.userInfo = {
        ...state.userInfo,
        ...payload,
      }
    },
    
    SET_USER_INFO_LOADED(state, loaded) {
      state.userInfoLoaded = loaded
    },
    
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    
    CLEAR_USER_INFO(state) {
      state.token = ''
      state.userInfo = {
        username: '',
        nickname: '',
        avatar: '',
        mobile: '',
        score: 0,
        gender: null,
        isSignedIn: false,
      }
      state.userInfoLoaded = false
      localStorage.removeItem('token')
    },
  },
  actions: {
    increment({ commit }) {
      commit('INCREMENT')
    },
    decrement({ commit }) {
      commit('DECREMENT')
    },
    
    async fetchUserInfo({ commit, state }) {
      
      if (!state.userInfoLoaded) {
        const username = localStorage.getItem('username')
        const avatar = localStorage.getItem('avatar')
        if (username || avatar) {
          commit('SET_USER_INFO', {
            username: username || '',
            nickname: username || '',
            avatar: avatar || '',
          })
        }
      }
      
      try {
        const res = await fetchUserInfo()
        const data = res.data || {}
        const updatedInfo = {
          username: data.username || data.nickname || state.userInfo.username || '',
          nickname: data.nickname || data.username || state.userInfo.nickname || '',
          avatar: data.avatar || state.userInfo.avatar || '',
          mobile: data.mobile || state.userInfo.mobile || '',
          score: data.score !== undefined ? data.score : state.userInfo.score,
          gender: data.gender !== undefined ? data.gender : state.userInfo.gender,
          isSignedIn: data.isSignedIn !== undefined ? data.isSignedIn : state.userInfo.isSignedIn,
          learningcountdown: data.learningcountdown !== undefined ? data.learningcountdown : (state.userInfo.learningcountdown || '5'),
          is_notebook: data.is_notebook !== undefined ? data.is_notebook : (state.userInfo.is_notebook !== undefined ? state.userInfo.is_notebook : 1),
          is_mistake: data.is_mistake !== undefined ? data.is_mistake : (state.userInfo.is_mistake !== undefined ? state.userInfo.is_mistake : 1),
          day_is_sign: data.day_is_sign !== undefined ? data.day_is_sign : (state.userInfo.day_is_sign !== undefined ? state.userInfo.day_is_sign : 0),
        }
        const mergedUserInfo = {
          ...state.userInfo,
          ...updatedInfo,
        }
        commit('SET_USER_INFO', mergedUserInfo)
        try {
          localStorage.setItem('userInfo', JSON.stringify(mergedUserInfo))
        } catch (e) {
          console.error('Failed to cache userInfo after fetchUserInfo', e)
        }
        commit('SET_USER_INFO_LOADED', true)
        return res
      } catch (error) {
        commit('SET_USER_INFO_LOADED', true)
        throw error
      }
    },
    
    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    
    setLoginInfo({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      commit('SET_USER_INFO_LOADED', true)
    },
    
    clearUserInfo({ commit }) {
      commit('CLEAR_USER_INFO')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('isLoggedIn')
    },
  },
  getters: {
    
    getToken: (state) => state.token,
    
    getUserInfo: (state) => state.userInfo,
    
    getUserName: (state) => state.userInfo.nickname || state.userInfo.username || '',
    
    getUserAvatar: (state) => state.userInfo.avatar || require('@/assets/bg.png'),
    
    isUserInfoLoaded: (state) => state.userInfoLoaded,
  }
})
